<template>
    <div id="change-type-dialog">
        <el-dialog title="履约担保形式转换" 
        :visible.sync="dialogShow" width="1000px" center
        :close-on-click-modal="false"
        :before-close='closeDilalog'>
            <el-form label-width="200px" :model="peChangeForm" ref="peChangeForm" :rules="rules" v-if="showType == 1">
                <el-form-item label="变更选项：" class="pe_change_type" prop="changeType">
                    <el-radio-group v-model="peChangeForm.changeType">
                        <el-radio v-if="nowType=='2'" :label="1">履约保函转为履约保证金</el-radio>
                        <el-radio v-if="nowType=='2'" :label="2">履约保函格式调整</el-radio>
                        <el-radio v-if="nowType=='1'" :label="3">履约保证金转为履约保函</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item v-if="peChangeForm.changeType == '1'" label="履约保证金到账时间：" prop="payDate">
                    <el-date-picker v-model="peChangeForm.payDate" type="date" placeholder="请选择履约保证金到账时间"
                                            value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
                </el-form-item>

                <el-form-item label="更换原因：" prop="changeReason">
                    <el-input type="textarea" v-model="peChangeForm.changeReason" :rows="4" :maxlength="255"></el-input>
                </el-form-item>

                <el-form-item label="上传附件：">
                    <el-upload
                        class="upload-demo"
                        :before-upload="beforeUpload"
                        :on-remove="handleRemoveFiles"
                        :action="uploadApi"
                        :on-success="addFilesHandle"
                        :on-error="uploadError"
                        multiple
                        :limit="6"
                        :file-list="peChangeForm.baseFiles">
                        <el-button size="small" type="primary">上 传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>
            </el-form>

            <el-form label-width="200px" v-if="showType == 2">
                <el-form-item label="变更选项：" class="pe_change_type">
                    {{ changeNameArray[peChangeForm.changeType] }}
                </el-form-item>

                <el-form-item v-if="peChangeForm.changeType == '1'" label="履约保证金到账时间：">
                    {{ peChangeForm.payDate }}
                </el-form-item>

                <el-form-item label="更换原因：">
                    {{peChangeForm.changeReason}}
                </el-form-item>

                <el-form-item label="上传附件：">
                    <div v-if="peChangeForm.baseFiles.length > 0">
                        <div v-for="(tempfile,fileIndex) in peChangeForm.baseFiles" :key="fileIndex">
                            <a :href="`${downUrl}?fileName=${tempfile.fileName}&fileOldName=${tempfile.fileOldName}`">
                                    {{ tempfile.fileOldName }}
                            </a>
                        </div>    
                    </div>
                    <div v-else>无</div>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDilalog">取 消</el-button>
                <el-button type="primary" @click="onSubmit">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import util from '@/util'
    export default {
        name: "change-type-dialog",
        props: {
            inviteProjectId: {
                type: String,
                default: null
            },
            entryId: {
                type: String,
                default: null
            },
            contractBillId: {
                type: String,
                default: null
            },
            nodeType: {
                type: Number,
                default: 1
            },
            nowType: { // 1：当前履约保证金 2: 当前履约保函
                type: String,
                default: null
            }
        },
        data(){
            return {
                dialogShow: false,
                peChangeForm: {
                    changeType: '',
                    payDate: '',
                    changeReason: '',
                    baseFiles: [],
                    nodeType: '',
                    inviteProjectId: null,
                    entryId: null,
                    contractBillId: null
                },
                rules: {
                    changeType: [{required: true, message: '变更选项必须选择', trigger: 'blur'}],
                    payDate: [{required: true, message: '履约保证金到账时间必须选择', trigger: 'blur'}],
                    changeReason: [{required: true, message: '更换原因必须填写', trigger: 'blur'}]
                },
                uploadApi: `${util.baseUrl}rest/file/upload`,
                downUrl: `${util.baseUrl}rest/file/down`,
                showType: 1, // 1：编辑模式，2：查看模式
                changeNameArray: [
                    '',
                    '履约保函转为履约保证金', 
                    '履约保函格式调整', 
                    '履约保证金转为履约保函', 
                    '履约保证金：投标保证金转为履约保证金，差额另补', 
                    '履约保证金：另全额缴纳履约保证金', 
                    '履约保函',
                    '履约保证金'
                ],
            }
        },
        created() {
        },
        computed: {
        },
        methods: {
            closeDilalog () {
                this.dialogShow = false
                this.resetForm()
            },
            // 上传文件格式验证
            beforeUpload (file) {
                if (file.size / 1024 / 1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M', '文件过大！', {type: 'error'})
                    return false
                }

                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },
            handleRemoveFiles (file, fileList) {
                this.peChangeForm.baseFiles = this.peChangeForm.baseFiles.filter((f) => {
                    return f.uid !== file.uid
                })
            },
            uploadError (err) {
                this.$message({message: (err || '上传出错，请稍后再试。'), type: 'error'})
            },
            addFilesHandle (response, file, fileList) {
                let fs = []
                fileList.forEach(function (item) {
                    console.log(item)
                    if (item.response) {
                        let f = item.response.basefiles[0]
                        // item.bizTableName = f.bizTableName
                        // item.bizTablePkName = f.bizTablePkName
                        // item.bizTablePkValue = f.bizTablePkValue
                        item.fid = f.fid
                        // item.fileCatagoryId = f.fileCatagoryId
                        // item.fileDesc = f.fileDesc
                        item.fileOldName = f.fileoldname
                        item.name = f.fileoldname
                        item.fileName = f.filename
                        item.filePath = f.filepath
                        item.fileSize = f.filesize
                        item.fileType = f.filetype
                    }
                    fs.push(item)
                })

                this.peChangeForm.baseFiles = fs
            },
            openDialog () {
                this.showType = 1
                this.dialogShow = true
            },
            onSubmit () {
                // 提交
                this.$refs.peChangeForm.validate((valid) => {
                    if (valid) {

                        if (this.peChangeForm.changeType != '1') {
                            this.peChangeForm.payDate = null
                        }

                        this.peChangeForm.nodeType = this.nodeType

                        if (this.peChangeForm.nodeType == '1') {
                            this.peChangeForm.inviteProjectId = this.inviteProjectId
                            this.peChangeForm.entryId = this.entryId
                        } else {
                            this.peChangeForm.contractBillId = this.contractBillId
                        }
                        
                        let tempParam = Object.assign({}, this.peChangeForm)

                        this.$http.post('rest/api/dsp/peChange/addChangeRecord', tempParam).then((res) => {
                            if (res.data.result) {
                                this.$message({type: 'success', message: '提交成功'})
                                this.dialogShow = false
                                this.resetForm()
                                this.$emit('addAfter')
                            }
                        })
                    }
                })
            },
            resetForm () {
                this.peChangeForm = {
                    changeType: '',
                    payDate: '',
                    changeReason: '',
                    baseFiles: [],
                    nodeType: '',
                    inviteProjectId: null,
                    entryId: null,
                    contractBillId: null
                }
            },
            setNowType (nowType) {
                this.nowType = nowType
            },
            openShowDialog (id) {
                this.$http.get(`rest/api/dsp/peChange/getChangeTypeInfo/${id}`).then((res) => {
                    if (res.data.result) {
                        this.showType = 2
                        this.peChangeForm = res.data.value
                        this.dialogShow = true
                    }
                })
            }
        }
    }
</script>

<style scoped lang="postcss">
    .pe_change_type .el-radio+.el-radio {
        margin-left: 0px;
    }
    .pe_change_type .el-radio {
        display: block;
        padding: 3px 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/components/ChangePeTypeDialog.vue